import {EquipmentData, EquipmentIdType, EquipmentPlain} from '../types'

/** Determines the type of equipment ID to use on search fields based on passed feature flag. */
export const getEquipmentIdType = (
  areExtendedEquipmentIdsEnabled: boolean
): EquipmentIdType | undefined => {
  return areExtendedEquipmentIdsEnabled ? 'sapNumber' : undefined
}

/** Compares two equipment options to determine if they are the same based on their IDs. */
export function areEquipmentsSame(option1: EquipmentPlain, option2: EquipmentPlain) {
  return option1 && option2 && option1.equipment.id === option2.equipment.id
}

/** Compares two main equipment options to determine if they are the same based on their IDs. */
export function areMainEquipmentsSame(option1: EquipmentData, option2: EquipmentData) {
  return option1 && option2 && option1.id === option2.id
}
